import {useState} from '@wordpress/element';
import {Button} from '@wordpress/components';
import {__} from '@wordpress/i18n';

const HelpPopover = () => {
    const [isPopoverVisible, setIsPopoverVisible] = useState(false);

    const togglePopover = () => {
        setIsPopoverVisible(!isPopoverVisible);
    };

    return (
        <>
            <Button
                variant="tertiary"
                icon="info"
                label={__('Help', 'simple-video-preview')}
                onClick={togglePopover}
                aria-expanded={isPopoverVisible}
            >
                {__('Help', 'simple-video-preview')}
            </Button>

            {isPopoverVisible && (
                <div className="simple-video-preview-popover">
                    <Button
                        icon="no-alt"
                        label={__('Close', 'simple-video-preview')}
                        onClick={togglePopover}
                        className="simple-video-preview-popover-close"
                    />
                    <h1>{__('Simple Video Preview', 'simple-video-preview')}</h1>
                    <p>{__('The plugin supports the following URL formats:', 'simple-video-preview')}</p>
                    <ul>
                        <li>
                            <strong>{__('YouTube:', 'simple-video-preview')}</strong>
                            <ul>
                                <li>https://www.youtube.com/watch?v=[VIDEO_ID]</li>
                                <li>https://www.youtube.com/shorts/[VIDEO_ID]</li>
                                <li>https://www.youtube.com/embed/[VIDEO_ID]</li>
                                <li>https://youtu.be/[VIDEO_ID]</li>
                            </ul>
                        </li>
                        <li>
                            <strong>{__('Wistia:', 'simple-video-preview')}</strong>
                            <ul>
                                <li>https://wistia.com/watch/wistia-overview?wchannelid=[CHANNEL_ID]&wmediaid=[MEDIA_ID]</li>
                                <li>https://home.wistia.com/medias/[MEDIA_ID]</li>
                                <li>https://fast.wistia.net/embed/iframe/[MEDIA_ID]</li>
                            </ul>
                        </li>
                        <li>
                            <strong>{__('Vimeo:', 'simple-video-preview')}</strong>
                            <ul>
                                <li>https://vimeo.com/[VIDEO_ID]</li>
                                <li>https://vimeo.com/[VIDEO_ID]_[VIDEO_TITLE]</li>
                            </ul>
                        </li>
                        <li>
                            <strong>{__('Dailymotion:', 'simple-video-preview')}</strong>
                            <ul>
                                <li>https://www.dailymotion.com/video/[VIDEO_ID]</li>
                                <li>https://www.dailymotion.com/embed/video/[VIDEO_ID]</li>
                            </ul>
                        </li>
                    </ul>
                </div>
            )}
        </>
    );
};

export default HelpPopover;
